import { MessagingBackend } from "@whatslly/commons/messagingBackend";
import { injectable } from "inversify";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import swUrl from "./serviceWorker/sw?url&worker";
import type { SWCommandsTypes } from "./serviceWorker/cmds";
import { SW_COMMANDS_PREFIX, SWCommands } from "./serviceWorker/cmds";
import { postJSON } from "@whatslly/commons/apiUtils";

export const serviceWorkerBackend = new MessagingBackend<SWCommandsTypes>(SWCommands, SW_COMMANDS_PREFIX);
const handler = serviceWorkerBackend.getHandler((event: MessageEvent) => ({ request: event.data, respond: (x) => event.source?.postMessage(x) }));
// navigator.serviceWorker is undefined in iOS in-app webviews (e.g. WhatsApp)
// and non-secure contexts. This module is evaluated at app boot — an unguarded
// access kills the whole bundle and leaves a blank page.
if (navigator.serviceWorker) {
  navigator.serviceWorker.addEventListener("message", handler);
}

@injectable()
export class TuvisNotificationsService {
  private initialized = false;
  pushSubscription?: PushSubscription;
  async getSubscription() {
    // Push notifications need both APIs; neither exists in iOS in-app webviews.
    if (!navigator.serviceWorker || typeof Notification === "undefined") return;
    await Notification.requestPermission();
    if (Notification.permission !== "granted" || this.initialized) {
      return;
    }
    if (this.pushSubscription) return this.pushSubscription;
    this.initialized = true;
    const registration = await navigator.serviceWorker.register(swUrl, { type: "module" });
    this.pushSubscription = await registration?.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: import.meta.env.VITE_PUSH_NOTIFICATION_PUBLIC_KEY,
    });
    return this.pushSubscription;
  }

  async init(userId?: string) {
    const subscription = await this.getSubscription();
    if (!subscription) return;
    await postJSON({
      urlSuffix: "/integrations/users/notifications/register",
      pod: import.meta.env.VITE_API_DEFAULT_POD,
      body: JSON.stringify({
        userId,
        subscribeData: { ...(subscription.toJSON() as any), type: "web-push" },
      }),
    });
  }
}
